import { i18n } from '@marine/i18n';
import type { OrgPlan } from './orgPlan';
import type { PlanCatalog } from './serverPlan';

/**
 * What the plan pages and the Overview's Boats tile say about the organization's plan and how much
 * of it is used. Plain functions, so the wording is tested without rendering.
 */

/** "Plus", or null for a plan the app doesn't know, which then gets no name rather than a wrong one. */
export const planName = (plan: OrgPlan, catalog: PlanCatalog): string | null =>
  plan.slug ? catalog[plan.slug].name : null;

/**
 * "350 MB" under a gigabyte, "2.4 GB" over it, "0 GB" for none. Never "0 MB" for something stored.
 */
export const formatStorage = (gb: number): string => {
  if (gb > 0 && gb < 1) {
    return `${Math.max(1, Math.round(gb * 1024))} MB`;
  }

  return `${Number(gb.toFixed(1))} GB`;
};

/**
 * The line under the Boats tile's count: "1 of 1 on Free".
 *
 * `null` while the plan isn't known, so the tile keeps its own line rather than naming a plan the
 * organization may not be on.
 */
export const boatsOnPlanLabel = (
  boats: number,
  plan: OrgPlan,
  isLoaded: boolean,
  catalog: PlanCatalog,
): string | null => {
  const name = planName(plan, catalog);

  if (!isLoaded || !name) {
    return null;
  }

  const limit = plan.limits.boats;

  return limit === null
    ? i18n.t('subscription:usage.boatsOnPlanUnlimited', { boats, plan: name })
    : i18n.t('subscription:usage.boatsOnPlan', { boats, limit, plan: name });
};
